export const FACEBOOK_PAGE = 'https://www.facebook.com/Les-Chiures-de-Mouches-43398522217/'
export const SOUNDCLOUD_PAGE = 'https://soundcloud.com/chiuresdemouches'